<template>
  <!-- <div class="box" style="height:calc(100% - 50px);">
    <div style="display: flex;width: 100%;height: 100%;">
      <div class="total" >
        <div><span class="span_number">{{totals}}</span><span class="span_text">个</span></div>
        <div>总计</div>
      </div>
    <div class="box-top">
      <div class="box-top-left"  v-for="(item,index) in list" :key="index">
        {{item.count}}
        <p class="box-p">{{item.gradeName}}(家)</p>
      </div>
    </div>
    </div>
  </div> -->
  <div
    v-loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-spinner="el-icon-loading"
    class="box"
  >
    <div ref="charts" style="width: 100%; height: 100%;"></div>
  </div>
</template>

<script>
import Cookies from "js-cookie"
import API from "@/api/bigScreen/api_big_screen";
export default {
  data() {
    return {
      list:[],
      // totals:0,
      loading: true,
      qhdm: Cookies.get('areacode'),
      charts: '',
      xData: []
    }
  },
   created() {
    //  this.enterpriseStatGrade();
      this.$nextTick(() => this.init())
      this.GLOBAL.eventBus.$on("refresh_big_screen_info",this.queryData);
   },
   beforeDestroy() {
      this.GLOBAL.eventBus.$off("refresh_big_screen_info",this.queryData);
   },
    methods: {
      queryData(qhdm){
        this.qhdm = qhdm;
        this.enterpriseStatGrade();
      },

      init() {
        this.enterpriseStatGrade()
      },

      getChartsOption(xData, greenData, indicationData, trademarkData, organicData ) {
        var barWidth = 15;

        return {
          backgroundColor: 'transparent',
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            backgroundColor: 'rgba(255,255,255,0.15)',
            borderColor: '#00D7FE',
            textStyle: {
              color: 'white',
              fontSize: 14,
              fontWeight: 'normal'
            }
          },
          grid: {
            left: 0,
            bottom: '5%',
            containLabel: true
          },
          legend: {
            show: true,
            top: 10,
            textStyle: {
                color: '#fff',
            },
          },
          xAxis: [{
            type : 'category',
            data: xData,
            splitLine: {
              show: false
            },
            axisLine: {
              show: false
            },
            axisTick: {
              alignWithLabel: false
            },
            axisLabel: {
              interval: 0,
              // rotate:45,
              textStyle: {
                color: '#fff',
                fontSize: 14,
              },
            },
          }],
          dataZoom: {
            show: true, // 为true 滚动条出现
            realtime: true,
            type:'slider', // 有type这个属性，滚动条在最下面，也可以不行，写y：36，这表示距离顶端36px，一般就是在图上面。
            height: 5, // 表示滚动条的高度，也就是粗细
            start: 40, // 表示默认展示20%～80%这一段。
            end: 70,
            bottom: '2%',
            showDetail: false,
            handleStyle: {
              color: '#fff'
            }
          },
          yAxis: [{
            type : 'value',
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitArea: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 14,
              },
            }
          }],
          series: [{
            name: '国家级',
            type: 'bar',
            stack: "总量",
            barWidth: barWidth,
            barCategoryGap: '-100%',
            barGap: 100,
            // barMinHeight: 30,
            itemStyle: {
              normal: {
                barBorderRadius: 50,
                borderWidth: 0,
                color:
                {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                      offset: 0,
                      color: 'rgba(255, 69, 0, 1)' // 0% 处的颜色
                  }, {
                      offset: 1,
                      color: 'rgba(255, 69, 0, 0)' // 100% 处的颜色
                  }],
                  global: false, // 缺省为 false
                }
              }
            },
            data: greenData
          },
          { //下半截柱子
            name: '省级',
            type: 'bar',
            stack: "总量",
            barWidth: barWidth,
            barCategoryGap: '10%',
            // barMinHeight: 28,
            itemStyle: {
              normal: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(3, 250, 83, 1)' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: 'rgba(3, 250, 83, 0)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                },
                barBorderRadius: 50,
                borderWidth: 0
              }
            },
            data: indicationData
          },
          { //下半截柱子
            name: '市级',
            type: 'bar',
            stack: "总量",
            barWidth: barWidth,
            // barMinHeight: 31,
            barCategoryGap: '10%',
            itemStyle: { //lenged文本
              barBorderRadius: 50,
              borderWidth: 0,
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(225, 225, 128, 1)' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: 'rgba(225, 225, 128, 0)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              },
            },
            data: trademarkData
          },
          { //下半截柱子
            name: '县级',
            type: 'bar',
            stack: "总量",
            barCategoryGap: '10%',
            // barMinHeight: 29,
            itemStyle: { //lenged文本
              barBorderRadius: 50,
              borderWidth: 0,
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(4, 237, 252, 1)' // 0% 处的颜色
                }, {
                  offset: 1,
                  color: 'rgba(4, 237, 252, 0)' // 100% 处的颜色
                }],
                global: false // 缺省为 false
              },
            },
            data: organicData
          }]
        }
      },

      async enterpriseStatGrade() {
        const res = await API.getGradeList({qhdm:this.qhdm});
        // const res = await API.getGradeList({qhdm: 45});
        console.log('res', res )
        if (res.code === 0) {

          const data1 = res.data.list.map((item) => {
            return item.gradeData.countryNum || 0
          })

          const data2 = res.data.list.map((item) => {
            return item.gradeData.provincialNum || 0
          })

          const data3 = res.data.list.map((item) => {
            return item.gradeData.cityNum || 0
          })

          const data4 = res.data.list.map((item) => {
            return item.gradeData.countyNum || 0
          })

          const Xdata = res.data.list.map((item) => {
            return item.qhmc
          })



        console.log('x', Xdata, data1, data2, data3, data4)

        this.loading = false
        this.charts = this.$echarts.init(this.$refs.charts)
        this.charts.setOption(this.getChartsOption(Xdata, data1, data2, data3, data4))
        //  this.totals= this.list.reduce((total, item) => {
        //   return total + item.count
        // }, 0)
      }
    },
  }
};
</script>

<style lang="less" scoped>
  .box {
    height: calc(100% - 40px);
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/studio/homepage/home/homeleftcentre.vue